<section class="page-back">
  <!-- start banner Area -->
  <section class="top-banner">
    <div class="top-banner-img" style="">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 style="padding: 30px 0px 0px 0px !important;"> Nouvel administrateur</h1>
            <p class="text-white link-nav"><a routerLink="/admin" style="color: #ff5a00 !important">Accueil </a> <span
                class="lnr lnr-arrow-right"></span>
              <a style="color: white;" routerLink="/admin/administrateur"> Nouvel administrateur</a>
            </p>

          </div>
        </div>
      </div>
    </div>
  </section>
  <br> <br>

  <!-- End banner Area -->

  <!-- Start service Area -->
  <section class="service-area section-gap" id="service">
    <div class="container">
      <!-- Form to save new Admin -->
      <div class="card">
        <div class="card-body">
          <div class="row d-flex justify-content-center">
            <form class="col-md-8 pb-40 form-area" [formGroup]="adminForm" (ngSubmit)="onSubmitForm()">
              <div class="row mt-5">
                <div class="form-group col-md-6">
                  <label for="name">Nom de l'admin<span class="star-style">**</span></label>
                  <input type="text" class="form-control" id="name" formControlName="name">
                </div>
                <div class="form-group col-md-6">
                  <label for="profile_id">Type admin<span class="star-style">**</span></label>
                  <select class="form-control" id="profile_id" formControlName="profile_id">
                    <option value="">Selectionner...</option>
                    <option value="2">Admin</option>
                    <option value="1">Super admin</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-12">
                  <label for="email">Email de l'admin<span class="star-style">**</span></label>
                  <input type="email" class="form-control" id="email" formControlName="email">
                </div>
              </div>
              <div class="row justify-content-center">
                <button type="submit" class="btn btn-primary text-white mb-4" [disabled]="adminForm.invalid"
                  *ngIf="!isLoading">Enregistrer</button>
                <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="isLoading">Veuillez
                  patienter...
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>


      <!-- Loading -->
      <div class="row d-flex justify-content-center mt-2 mb-4" *ngIf="loadingForList">
        <span style="color: red">Chargement...</span>
      </div>

      <!-- Nb record find -->
      <div class="row mt-4 mb-4">
        <span style="color: green">{{ adminList.length }} enregistrement (s) trouvé(s)</span>
      </div>
      <div class="card mb-5">
        <div class="card-body">
          <table class="table borderless">
            <tr>
              <th>Nom & Prénoms</th>
              <th>Rôle</th>

              <th>Action</th>
            </tr>
            <tr *ngFor="let admin of adminList">
              <td>{{ admin.getName() }}
              </td>
              <td>{{ admin.getProfilesName() }}</td>

              <td>
                <span *ngIf="currentAdmin.getProfilesId() == '1'"><button class="btn btn-warning mr-2"
                    (click)="editAdmin(admin)">Editer</button></span>
                <span *ngIf="currentAdmin.getId() != admin.getId()"><button class="btn btn-danger mr-2"
                    *ngIf="admin.getIsDelete() === false"
                    (click)="lockUnlock(admin.getEmail(), 'true')">Supp.</button></span>
                <button class="btn btn-success mr-2" *ngIf="admin.getIsDelete() === true"
                  (click)="lockUnlock(admin.getEmail(), 'false')">Rest.</button>
              </td>
            </tr>
          </table>
        </div>
      </div>

    </div>
  </section>
  <!-- End service Area -->
</section>